// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {
	BasicMaterialDialog,
	MatDialogDataBaseInput,
	MatDialogDataBaseOutput,
} from "../../basic-material-dialog/basic-material-dialog.directive";
import {SimMaterialDialogService, NotificationService, SimPowerDistributionUnitService} from "@services";
import {PowerDistributionUnit} from "@models";

export interface DialogData_PowerDistributionUnitConfigurationDialogInput extends MatDialogDataBaseInput {
	powerDistributionUnit: PowerDistributionUnit;
}

export interface DialogData_PowerDistributionUnitConfigurationDialogOutput extends MatDialogDataBaseOutput {
	powerDistributionUnit?: PowerDistributionUnit;
}

@Component({
	selector: "sim-power-distribution-unit-configuration-dialog",
	templateUrl: "./power-distribution-unit-configuration-dialog.component.html",
	styleUrls: ["./power-distribution-unit-configuration-dialog.component.scss"],
	standalone: false,
})
export class PowerDistributionUnitConfigurationDialogComponent extends BasicMaterialDialog<
	PowerDistributionUnitConfigurationDialogComponent,
	DialogData_PowerDistributionUnitConfigurationDialogInput,
	DialogData_PowerDistributionUnitConfigurationDialogOutput
> {
	public updateAllPDUsTask: Promise<boolean>;
	public hidePassword = true;

	constructor(
		_injector: Injector,
		private _simPowerDistributionUnitService: SimPowerDistributionUnitService,
		private _simMatDialogService: SimMaterialDialogService,
		private _simNotificationService: NotificationService,
	) {
		super(_injector);
	}

	async updateAllPDUs(propertyName: string, propertyValue: string) {
		const {action} = await this._simMatDialogService.openGeneralWarningDialog({
			warningTitle: "Change all PDUs",
			warningDescription: "Do you really want to update this configuration value for all PDUs? ",
			warningOkText: "Yes",
		});

		if (action === "ok") {
			this.updateAllPDUsTask = this._simPowerDistributionUnitService.updateAllPowerDistributionUnits({
				propertyName,
				propertyValue,
			});

			const success = await this.updateAllPDUsTask;
			if (success) {
				this.data.powerDistributionUnit[propertyName] = propertyValue;
				this._simNotificationService.notifySuccess("Successfully updated all PDUs");
			} else {
				this._simNotificationService.notifyError("Failed to update all PDUs");
			}
		}
	}
}
